import React from 'react';
import ReactDOM from 'react-dom/client';
import 'formiojs/dist/formio.full.min.css';
import './index.css';
import App from './App';
import { RecoilRoot } from 'recoil';
import { ConfigProvider } from "antd";
import { BrowserRouter } from 'react-router-dom';
import SocketProvider from './socket/SocketProvider';

// SockJS expects a Node-style `global` in browser bundles.
if (typeof window !== 'undefined' && typeof window.global === 'undefined') {
  window.global = window;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <RecoilRoot>
      <SocketProvider>
        <React.StrictMode>
          <ConfigProvider>
            <App />
          </ConfigProvider>
        </React.StrictMode>
      </SocketProvider>
    </RecoilRoot>
  </BrowserRouter>
);
